<template>
  <c-modal title="Invoice #123987" size="lg" :show="showInvoice" @update:show="$emit('close')">
    <p class="lead">{{ invoice.createdAt | dateFormatNoTime }}</p>
    <p class="lead">{{ invoice.description }}</p>
    <p class="lead">{{ (invoice.amount / 100) | formatAsCurrency }} {{invoice.currency.toUpperCase()}}</p>
    <template v-slot:footer>
      <a target="_blank" :href="invoice.receiptUrl">Open receipt</a>
      <c-button-group>
        <c-button color="secondary" @click="$emit('close')">Close</c-button>
      </c-button-group>
    </template>
  </c-modal>
</template>

<script>
export default {
  props: {
    invoice: {
      type: Object,
      default: null,
    },
    showInvoice: Boolean,
  },
  components: {
  },
  data() {
    return {
    };
  },
};
</script>
